// Duits (de-DE), groeiSchoolApp: zelfde vorm als groeiSchoolApp.nl.ts (golf 3-integratie). Du-Form,
// kein Urteil über ein Kind. Niederländische Schulbegriffe (AVI, Cito, vmbo, havo, vwo, groep)
// bleiben stehen, so stehen sie im Zeugnis. Die Einwilligung fällt unter GROWTH_CONSENT_TEXT_HASHES.
export const appGrowthDe = {
    title: 'Wachstum',
    intro: 'Größe und Gewicht eurer Kinder, ruhig in einer Wachstumskurve. Nur Eltern sehen das. Nicht auf dem Tablet, außer ein Elternteil bestätigt das selbst ausdrücklich für ein Tablet; das lässt sich jederzeit wieder wegnehmen.',
    tab: 'Wachstum',
    empty: 'Noch keine Messungen. Miss in Ruhe, zum Beispiel nach dem Besuch beim Consultatiebureau oder der JGZ.',
    measurements: '{count} Messungen',
    measurementsOne: '1 Messung',
    lastOn: 'Zuletzt gemessen am {date}',
    open: 'Wachstum von {name}',
    noConsentYet: 'Noch nicht eingeschaltet',
    noMeasurements: 'Noch keine Messungen',
    consent: {
        version: '2026-10-08.1',
        title: 'Wachstum für {name} festhalten?',
        parental: {
            text: 'Größe und Gewicht sind Gesundheitsdaten. Wir speichern sie nur, um das Wachstum von {name} in einem Diagramm zu zeigen.\nWählst du eine Referenzgruppe für die Wachstumskurve (Kinder türkischer, marokkanischer oder hindostanischer (surinamischer) Herkunft in den Niederlanden), speichern wir diese Wahl auch. Sie verrät etwas über die Herkunft.\nWurde {name} zu früh geboren, kannst du die Schwangerschaftsdauer bei der Geburt eintragen. Auch das ist ein Gesundheitsdatum.\nNur die Eltern in dieser Familie sehen es. Nie für Kinder und nie für verbundene Verwandte. Nicht auf dem Tablet, außer ein Elternteil bestätigt das selbst ausdrücklich für ein Tablet; das lässt sich jederzeit wieder wegnehmen.\nDu kannst alles herunterladen. Ein Widerruf löscht alle Messungen und Einstellungen von {name} sofort; aus Sicherungen verschwinden sie innerhalb von 90 Tagen.\nDie Linien sind eine Hilfe, kein Urteil und keine Diagnose. Wenn du unsicher bist, frag beim Consultatiebureau oder der JGZ nach.\nAMUMIN B.V. ist für diese Daten verantwortlich. Deine Rechte stehen in der Datenschutzerklärung.',
            check: 'Ich bin Elternteil von {name} ({name} ist jünger als 16) und willige ein, dass Größe, Gewicht und die Einstellungen für die Wachstumskurve von {name} festgehalten werden.',
        },
        self: {
            text: 'Größe und Gewicht sind Gesundheitsdaten. Wir speichern sie nur, um dein Wachstum in einem Diagramm zu zeigen.\nWird für deine Wachstumskurve eine Referenzgruppe gewählt (zum Beispiel türkischer, marokkanischer oder hindostanischer (surinamischer) Herkunft in den Niederlanden), speichern wir diese Wahl auch. Sie verrät etwas über die Herkunft. Dasselbe gilt für die Schwangerschaftsdauer bei deiner Geburt, wenn du zu früh geboren wurdest: Das ist ein Gesundheitsdatum.\nNur die Eltern in dieser Familie sehen es (also auch der andere Elternteil). Nie für Kinder und nie für verbundene Verwandte. Nicht auf dem Tablet, außer ein Elternteil bestätigt das selbst ausdrücklich für ein Tablet; das lässt sich jederzeit wieder wegnehmen.\nDu kannst alles herunterladen. Ein Widerruf löscht alle deine Messungen und Einstellungen sofort; aus Sicherungen verschwinden sie innerhalb von 90 Tagen.\nAMUMIN B.V. ist für diese Daten verantwortlich. Deine Rechte stehen in der Datenschutzerklärung.',
            check: 'Ich willige ein, dass meine eigene Größe, mein Gewicht und die Einstellungen für meine Wachstumskurve festgehalten werden.',
        },
        /**
         * Aanvulling (0051, tekst 2026-09-28.1): gevraagd op het moment dat een ouder een keuze maakt
         * die een oudere toestemming niet noemde (hs_nl, zwangerschapsduur; bij `self` elke groep
         * behalve nl). De aanvulling noemt altijd ALLE keuzes die die tekst toevoegt (groep en
         * zwangerschapsduur), ook als de ouder er nu maar één kiest: dan dekt ze ze ook echt (review
         * gpl-reg r1). Hoort bij dezelfde hash als parental en self.
         */
        extension: {
            title: 'Einwilligung für diese Angaben',
            intro: 'Du hast für {name} schon in Wachstum eingewilligt. Der Text von damals nannte noch nicht alles, was du jetzt wählen kannst. Deshalb fragen wir gesondert nach deiner Einwilligung für diese zwei Angaben, auch wenn du jetzt nur eine davon wählst:',
            group: 'Eine Referenzgruppe für die Linien, zum Beispiel türkischer, marokkanischer oder hindostanischer (surinamischer) Herkunft in den Niederlanden. Diese Wahl verrät etwas über die Herkunft: Das ist eine besondere Kategorie personenbezogener Daten.',
            gestation: 'Die Schwangerschaftsdauer bei der Geburt, wenn {name} zu früh geboren wurde (22 bis 36 Wochen). Das ist ein Gesundheitsdatum.',
            rest: 'Wir nutzen es nur für die Linien im Diagramm. Nur die Eltern in dieser Familie sehen es. Nicht auf dem Tablet, außer ein Elternteil bestätigt das selbst ausdrücklich für ein Tablet; das lässt sich jederzeit wieder wegnehmen. Ein Widerruf löscht es sofort, zusammen mit den Messungen. Die Linien sind kein Urteil und keine Diagnose.\nMit dieser Einwilligung gilt für {name} der neueste Text der Einwilligung für Wachstum.',
            check: 'Ich willige ein, dass diese Angaben für {name} gespeichert werden.',
            selfText: 'Deine Eltern können für deine Wachstumskurve eine Referenzgruppe wählen (zum Beispiel türkischer, marokkanischer oder hindostanischer (surinamischer) Herkunft in den Niederlanden). Das verrät etwas über die Herkunft. Wurdest du zu früh geboren, können sie auch die Schwangerschaftsdauer bei deiner Geburt eintragen: Das ist ein Gesundheitsdatum. Für beides braucht es deine Einwilligung.',
            selfCheck: 'Ich willige ein, dass diese Einstellungen für meine eigene Wachstumskurve gespeichert werden.',
            give: 'Einwilligen und speichern',
            giveSelf: 'Einwilligung geben',
            needsOwn: '{name} entscheidet das selbst: {name} kann es unter Wachstum in der eigenen App erlauben.',
            selfTitle: 'Deine Einwilligung, mit dem neuen Text',
            extended: 'Am {date} um den neuesten Text ergänzt.',
        },
        give: 'Einwilligung geben',
        privacyLink: 'Datenschutzerklärung lesen',
        notNow: 'Nicht jetzt',
        needsOwn: 'Für {name} kann nur {name} selbst einwilligen, mit einem eigenen Login.',
        needsOwnTeen: 'Ab 16 Jahren entscheidet {name} selbst. Mit einem eigenen Login kann {name} unter Wachstum selbst einwilligen; danach könnt ihr die Messungen eintragen.',
        lapsed: '{name} ist jetzt 16 und entscheidet selbst. Du kannst die Messungen noch ansehen, herunterladen oder löschen, aber nicht mehr ergänzen.',
        given: 'Einwilligung gegeben am {date}',
        givenSelf: 'Du hast am {date} selbst eingewilligt',
        givenByThem: '{name} hat am {date} selbst eingewilligt',
        withdraw: 'Einwilligung widerrufen und alles löschen',
        withdrawTitle: 'Einwilligung widerrufen?',
        withdrawBody: 'Alle Messungen von {name} werden sofort gelöscht, ebenso die Wahl für die Wachstumskurve. Das lässt sich nicht rückgängig machen.',
        withdrawConfirm: 'Widerrufen und löschen',
        withdrawn: 'Einwilligung widerrufen. Die Messungen von {name} sind gelöscht.',
    },
    add: 'Messung hinzufügen',
    edit: 'Messung ändern',
    date: 'Datum',
    length: 'Größe (cm)',
    weight: 'Gewicht (kg)',
    lengthShort: 'Größe',
    weightShort: 'Gewicht',
    bmi: 'BMI',
    wflShort: 'Gewicht/Größe',
    note: 'Notiz (optional)',
    notePlaceholder: 'Zum Beispiel: bei der JGZ gemessen',
    oneOfBoth: 'Gib Größe, Gewicht oder beides ein.',
    saved: 'Messung gespeichert',
    deleted: 'Messung gelöscht',
    deleteConfirm: 'Diese Messung löschen?',
    errors: {
        empty: 'Gib Größe, Gewicht oder beides ein.',
        length_range: 'Diese Größe stimmt nicht. Gib sie in Zentimetern ein, zum Beispiel 123,5.',
        weight_range: 'Dieses Gewicht stimmt nicht. Gib es in Kilo ein, zum Beispiel 24,5.',
        future: 'Dieses Datum liegt in der Zukunft.',
        before_birth: 'Dieses Datum liegt vor dem Geburtsdatum.',
        note_long: 'Die Notiz ist zu lang (höchstens 200 Zeichen).',
        format: 'Verwende höchstens eine Nachkommastelle.',
    },
    chart: {
        length: 'Größe nach Alter',
        weight: 'Gewicht nach Alter',
        bmi: 'BMI nach Alter',
        wfl: 'Gewicht nach Größe',
        bmiFrom2: 'Den BMI zeigen wir ab 2 Jahren.',
        age: 'Alter (Jahre)',
        date: 'Datum',
        median: 'Mitte (Durchschnitt)',
        sd1: '−1 und +1 SD',
        sd2: '−2 und +2 SD',
        you: '{name}',
        lastPoint: 'Letzte Messung: {value} am {date}',
        info: 'Die Linien sind eine Hilfe, kein Urteil und keine Diagnose. Wenn du unsicher bist, frag beim Consultatiebureau oder der JGZ nach.',
        gaps: {
            no_sex: 'Wähle unten Junge oder Mädchen, um die Wachstumslinien zu sehen.',
            no_group: 'Wähle unten eine Referenzgruppe, um die Wachstumslinien zu sehen. Ohne Wahl siehst du nur die Messungen.',
            no_birth_date: 'Gib das Geburtsdatum ein, um das Wachstum nach Alter zu sehen.',
        },
        source: 'Quelle der Linien: {source}',
        sources: {
            schonbeck_2011: 'Niederländische Kinder, 2009 ({cite})',
            tno_2010: 'Niederländische Kinder, 2009 ({cite})',
            tno_2010_origin: 'Kinder {group} in den Niederlanden, 2009 ({cite})',
            fredriks_2000: 'Niederländische Kinder, 1997 ({cite})',
            fredriks_2003: 'Kinder {group} in den Niederlanden, 1997 ({cite})',
            fredriks_2004: 'Kinder {group} in den Niederlanden, 1997 ({cite})',
            de_wilde_2014: 'Kinder {group} in den Niederlanden, 2010 ({cite})',
            de_wilde_2013: 'Kinder {group} in den Niederlanden, 1976 ({cite})',
            bocca_2012: 'Kinder, geboren nach {weeks} Schwangerschaftswochen ({cite})',
            bocca_2012_wfh: 'Zu früh geborene Kinder ({cite})',
        },
        citations: {
            schonbeck_2011: 'Schönbeck u. a., PLoS ONE 2011, CC BY',
            tno_2010: 'TNO, Groeidiagrammen 2010',
            tno_2010_origin: 'TNO, Groeidiagrammen 2010',
            fredriks_2000: 'TNO, Fredriks u. a. 2000',
            fredriks_2003: 'TNO, Fredriks u. a. 2003',
            fredriks_2004: 'TNO, Fredriks u. a. 2004',
            de_wilde_2014: 'TNO, de Wilde u. a. 2014',
            de_wilde_2013: 'TNO, de Wilde u. a. 2013',
            bocca_2012: 'TNO, Bocca-Tjeertes u. a. 2012',
            bocca_2012_wfh: 'TNO, Bocca-Tjeertes u. a. 2012',
        },
        /** Golf 19: welke lijnen waar gelden (een tabel per stuk, zie referenceSegments). */
        rangeUntil: 'bis {age} Jahre:',
        rangeBetween: '{from} bis {to} Jahre:',
        rangeFrom: 'ab {age} Jahren:',
        sourceJoin: '; ',
        switchNote: 'Mit {age} Jahren wechseln die Linien zu einer anderen Tabelle (siehe die Quelle unten). Dort können sie etwas springen.',
        pretermNote: 'Bis {age} Jahre siehst du die Linien für Kinder, die nach {weeks} Schwangerschaftswochen geboren sind, nach dem Alter ab der Geburt. Danach die üblichen Linien.',
        pretermWflNote: 'Bis {age} Jahre siehst du hier die Linien für zu früh geborene Kinder. Danach die üblichen Linien.',
        table: 'Tabelle mit allen Messungen',
        showTable: 'Als Tabelle zeigen',
        showChart: 'Als Diagramm zeigen',
    },
    settings: {
        title: 'Wachstumskurve',
        sex: 'Geschlecht (für die Wachstumslinien)',
        sexUnset: 'Nicht gewählt',
        female: 'Mädchen',
        male: 'Junge',
        group: 'Referenzgruppe',
        groupHint: 'Nur für die Linien im Diagramm. Wähle, was am besten passt; du kannst es jederzeit ändern oder leer lassen.',
        groups: {
            none: 'Keine (nur Messungen)',
            nl: 'Niederländische Kinder',
            tr_nl: 'Kinder türkischer Herkunft in den Niederlanden',
            ma_nl: 'Kinder marokkanischer Herkunft in den Niederlanden',
            hs_nl: 'Kinder hindostanischer (surinamischer) Herkunft in den Niederlanden',
        },
        groupNames: {
            nl: 'niederländischer Herkunft',
            tr_nl: 'türkischer Herkunft',
            ma_nl: 'marokkanischer Herkunft',
            hs_nl: 'hindostanischer (surinamischer) Herkunft',
        },
        /** Golf 19: neutrale uitleg bij de groepen en de zwangerschapsduur (alleen te vroeg). */
        groupInfo: 'Die Linien jeder Gruppe stammen aus niederländischer Forschung mit Kindern dieser Herkunft. Hindostanisch (surinamisch) meint Kinder mit südasiatischen Vorfahren, oft über Surinam. Nicht jede Gruppe hat für jedes Maß eigene Linien; unter dem Diagramm steht, welche Linien du siehst.',
        gestation: 'Schwangerschaftsdauer bei der Geburt',
        gestationNone: 'Rechtzeitig geboren (oder nicht angegeben)',
        gestationWeeks: '{weeks} Wochen',
        gestationHint: 'Nur ausfüllen, wenn {name} zu früh geboren ist (vor {term} Wochen). Bis {age} Jahre siehst du dann die Linien für zu früh geborene Kinder; bei {min} bis {max} Wochen sind das die Linien für {table} Wochen. Das ist eine Gesundheitsangabe: Sie fällt unter dieselbe Einwilligung wie die Messungen, nur Eltern sehen sie, und ein Widerruf löscht sie ebenfalls.',
        saved: 'Gespeichert',
    },
    birthDate: 'Geburtsdatum von {name}',
    birthDateHint: 'Nötig für das Wachstum nach Alter. Steht auch bei den Geburtstagen.',
    download: 'Herunterladen',
    downloadCsv: 'Als Tabelle (CSV)',
    downloadJson: 'Alles (JSON)',
    clear: 'Alle Messungen löschen',
    clearTitle: 'Alle Messungen von {name} löschen?',
    clearBody: 'Die Einwilligung bleibt bestehen, damit du neu anfangen kannst. Das lässt sich nicht rückgängig machen.',
    cleared: 'Alle Messungen von {name} sind gelöscht.',
    privacyNote: 'Nur Eltern sehen das. Nicht auf dem Tablet, außer ein Elternteil bestätigt das selbst ausdrücklich für ein Tablet; das lässt sich jederzeit wieder wegnehmen.',
    selfIntro: 'Deine Größe und dein Gewicht, ruhig in einer Wachstumskurve. Deine Eltern tragen die Messungen ein; nur du und deine Eltern sehen das.',
    selfUnder16: 'Deine Eltern halten deine Größe und dein Gewicht fest. Ab 16 entscheidest du das selbst.',
    selfNote: 'Nur du und deine Eltern sehen das. Nicht auf dem Tablet, außer ein Elternteil bestätigt das selbst ausdrücklich für ein Tablet; das lässt sich jederzeit wieder wegnehmen.',
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: ['datum', 'groesse_cm', 'gewicht_kg', 'bmi', 'notiz'],
    moduleOff: 'Wachstum gehört zum Modul Gesundheit. Das ist ausgeschaltet.',
};
export const appSchoolDe = {
    title: 'Schule',
    intro: 'Zeugnisnoten und Tests pro Kind, ruhig auf einer Zeitleiste. Nur Eltern sehen das; nie auf dem Tablet.',
    childIntro: 'Deine Zeugnisse und Tests. Deine Eltern tragen sie ein.',
    childOff: 'Deine Eltern haben das für dich noch nicht eingeschaltet.',
    tab: 'Schule',
    open: 'Schule von {name}',
    noChildren: 'In eurer Familie gibt es noch keine Kinder.',
    empty: 'Noch nichts eingetragen. Fang mit dem letzten Zeugnis oder einem Test an.',
    nothingYet: 'Noch nichts eingetragen',
    count: '{count} Ergebnisse',
    countOne: '1 Ergebnis',
    add: 'Ergebnis hinzufügen',
    edit: 'Ergebnis ändern',
    saved: 'Gespeichert',
    deleted: 'Gelöscht',
    deleteConfirm: 'Dieses Ergebnis löschen?',
    timeline: 'Zeitleiste',
    trends: 'Pro Fach',
    noTrend: 'Eine Linie erscheint, sobald es zwei oder mehr Ergebnisse gibt.',
    childView: 'Darf {name} das selbst sehen?',
    childViewHint: 'Nur mit eigenem Login in der Web-App, nur die eigenen Ergebnisse und nur lesen. Nie auf dem Tablet.',
    childViewOn: '{name} kann das jetzt selbst sehen.',
    childViewOff: '{name} sieht das nicht.',
    download: 'Herunterladen',
    downloadCsv: 'Als Tabelle (CSV)',
    downloadJson: 'Alles (JSON)',
    clear: 'Alles von {name} löschen',
    clearTitle: 'Alle Ergebnisse von {name} löschen?',
    clearBody: 'Das lässt sich nicht rückgängig machen.',
    cleared: 'Alle Ergebnisse von {name} sind gelöscht.',
    field: {
        kind: 'Art',
        schoolYear: 'Schuljahr',
        period: 'Zeitpunkt',
        date: 'Datum (optional)',
        group: 'Gruppe (groep)',
        groupNone: 'Unbekannt',
        subject: 'Fach',
        domain: 'Bereich',
        scale: 'Skala',
        grade: 'Note',
        gradeHint: 'Von 1 bis 10, zum Beispiel 7,5',
        word: 'Bewertung',
        level: 'Niveau',
        score: 'Kompetenzwert (optional)',
        dmtScore: 'Punktzahl (Anzahl richtiger Wörter)',
        provider: 'Test von (optional)',
        note: 'Notiz (optional)',
    },
    errors: {
        school_year: 'Wähle ein Schuljahr.',
        period: 'Wähle einen Zeitpunkt, der zu dieser Art passt.',
        group: 'Wähle eine Gruppe von 1 bis 8.',
        subject: 'Wähle ein Fach.',
        domain: 'Wähle einen Bereich.',
        scale: 'Wähle eine Skala.',
        value: 'Dieser Wert passt nicht zur Skala.',
        provider: 'Wähle einen Test aus der Liste.',
        note: 'Die Notiz ist zu lang (höchstens 200 Zeichen).',
        future: 'Dieses Datum liegt in der Zukunft.',
        subject_dup: 'Dieses Fach gibt es schon.',
    },
    /** Titels van een lijn "Per vak" (review g3-ux r1): rapport en toets nooit dezelfde titel. */
    titles: {
        grade: '{subject} · Zeugnis',
        lvs: 'Test · {domain}',
    },
    kinds: {
        grade: 'Zeugnisnote',
        lvs: 'Test (Schülerbeobachtungssystem, LVS)',
        avi: 'AVI-Leseniveau',
        dmt: 'DMT (Drei-Minuten-Test)',
        level: 'Funktionsniveau (functioneringsniveau)',
        doorstroom: 'Übergangstest Gruppe 8 (doorstroomtoets)',
        advies: 'Schulempfehlung (schooladvies)',
    },
    periods: {
        b: 'Anfang',
        r1: 'Zeugnis 1',
        m: 'Mitte',
        r2: 'Zeugnis 2',
        r3: 'Zeugnis 3',
        e: 'Ende',
        r4: 'Zeugnis 4',
        voorlopig: 'Vorläufig',
        definitief: 'Endgültig',
    },
    periodsShort: {
        b: 'A',
        r1: 'Z1',
        m: 'M',
        r2: 'Z2',
        r3: 'Z3',
        e: 'E',
        r4: 'Z4',
        voorlopig: 'vorl.',
        definitief: 'endg.',
    },
    scales: {
        number: 'Note 1-10',
        word: 'Wörter (O bis ZG)',
        roman: 'I bis V',
        letter: 'A bis E',
        ref: '1F / 2F / 1S',
    },
    domains: {
        rekenen: 'Rechnen',
        begrijpend_lezen: 'Leseverständnis',
        spelling: 'Rechtschreibung',
        technisch_lezen: 'Lesefertigkeit',
        lezen: 'Lesen',
        taalverzorging: 'Sprachrichtigkeit',
    },
    providers: {
        cito: 'Cito (Leerling in beeld)',
        boom: 'Boom LVS',
        iep: 'IEP',
        dia: 'Diatoetsen',
        amn: 'AMN',
        route8: 'ROUTE 8',
        doe: 'DOE-toets',
        other: 'Andere',
    },
    words: {
        O: 'Ungenügend',
        M: 'Mäßig',
        V: 'Ausreichend',
        RV: 'Mehr als ausreichend',
        G: 'Gut',
        ZG: 'Sehr gut',
    },
    advice: {
        pro: 'Praktijkonderwijs (praxisorientierter Unterricht)',
        vmbo_b: 'vmbo basis',
        vmbo_b_k: 'vmbo basis / kader',
        vmbo_k: 'vmbo kader',
        vmbo_k_gt: 'vmbo kader / gt',
        vmbo_gt: 'vmbo gemengd/theoretisch (gt)',
        vmbo_gt_havo: 'vmbo gt / havo',
        havo: 'havo',
        havo_vwo: 'havo / vwo',
        vwo: 'vwo',
    },
    explain: {
        grade: 'Eine Zeugnisnote von 1 bis 10. Eine 5,5 oder höher ist ausreichend.',
        word: '{code} = {word}.',
        aviStart: 'AVI-Start = der Anfang des Lesenlernens, in Gruppe 3.',
        aviPlus: 'AVI-Plus = das höchste AVI-Niveau, nach Ende Gruppe 7.',
        avi: 'AVI {code} = das Leseniveau {moment} Gruppe {group}.',
        level: '{code} = das Niveau {moment} Gruppe {group}.',
        roman: {
            I: 'I = bei den besten 20 % der Kinder in den Niederlanden.',
            II: 'II = knapp über dem Durchschnitt (die nächsten 20 %).',
            III: 'III = rund um den Durchschnitt (die mittleren 20 %).',
            IV: 'IV = knapp unter dem Durchschnitt (die nächsten 20 %).',
            V: 'V = bei den unteren 20 %. Die Schule schaut dann, was zusätzlich hilft.',
        },
        letter: {
            A: 'A = bei den besten 25 % der Kinder in den Niederlanden.',
            B: 'B = knapp über dem Durchschnitt (die nächsten 25 %).',
            C: 'C = knapp unter dem Durchschnitt (die nächsten 25 %).',
            D: 'D = deutlich unter dem Durchschnitt (die nächsten 15 %).',
            E: 'E = bei den unteren 10 %. Die Schule schaut dann, was zusätzlich hilft.',
        },
        ref: {
            '<1F': '1F noch nicht erreicht. Das ist das Grundniveau für Ende Gruppe 8.',
            '1F': '1F = das Grundniveau, das fast alle Kinder Ende Gruppe 8 erreichen.',
            '2F': '2F = das Zielniveau für Lesen und Sprache Ende Gruppe 8.',
            '1S': '1S = das Zielniveau für Rechnen Ende Gruppe 8.',
        },
        dmt: 'Der DMT misst, wie viele einzelne Wörter ein Kind in drei Minuten richtig liest.',
        doorstroom: 'Der Übergangstest (seit 2024) misst Lesen, Sprachrichtigkeit und Rechnen in 1F, 2F und 1S.',
        advies: 'Die Schulempfehlung sagt, welche Art weiterführender Schule passt.',
        moments: { B: 'zu Beginn der', M: 'in der Mitte der', E: 'am Ende der' },
    },
    subjects: {
        title: 'Fächer',
        hint: 'Die Fächer im Zeugnis eurer Schule. Du kannst sie umbenennen oder entfernen; alte Noten bleiben erhalten.',
        add: 'Fach hinzufügen',
        name: 'Name des Fachs',
        suggested: 'Standardfächer hinzufügen',
        suggestions: [
            'Rechnen',
            'Sprache',
            'Rechtschreibung',
            'Lesen',
            'Leseverständnis',
            'Schreiben',
            'Erdkunde',
            'Geschichte',
            'Naturkunde',
            'Englisch',
        ],
        remove: 'Entfernen',
        rename: 'Umbenennen',
        removed: 'Fach entfernt. Alte Noten bleiben erhalten.',
        none: 'Noch keine Fächer. Füge sie hinzu oder wähle die Standardfächer.',
        archived: '{name} (entfernt)',
    },
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: [
        'schuljahr',
        'zeitraum',
        'datum',
        'gruppe',
        'art',
        'fach_oder_bereich',
        'wert',
        'test',
        'notiz',
    ],
    moduleOff: 'Schule ist ausgeschaltet.',
};
//# sourceMappingURL=groeiSchoolApp.de.js.map